import { mainPathBuilder as conversation } from '@guiker/conversation-shared'
import { mainPathBuilder as investment } from '@guiker/investment-shared'
import { mainPathBuilder as rentalTenancy } from '@guiker/rental-tenancy-shared'

export const pathBuilder = {
  conversation,
  investment,
  rentalTenancy,
}
